import WxConfig from './wxconfig'
import wx from 'weixin-js-sdk'
class WxSdk {
  static ready = () => {
    return new Promise((resolve, reject) => {
      WxConfig.share().then((res) => {
        if (res) {
          console.log('微信初始化验证成功, readytrue', res)
          resolve('微信初始化验证成功, true')
        } else {
          console.log('微信初始化验证失败, readyfalse')
          reject('微信初始化验证失败, false')
        }
      })
    })
  }
  // 微信扫一扫
  static scanQR = (code = '') => {
    if (tuhu.device.isWeixin) {
      console.log('调用扫一扫')
      WxConfig.share(['scanQRCode']).then((status) => {
      console.log('配置是否成功1', status)
            wx.scanQRCode({
              desc: 'scanQRCode desc',
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                console.log('qrCode', res)
                let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                tuhu.navigateTo({
                  url: '/pages/verifyCode/index',
                    data: {
                      verifyCode: result
                    },
                    query: {
                      success: 1
                    }
                  })
                },
                fail: function (err) {
                  console.log('scanQR-err', err)
				          tuhu.toast('网络错误,请刷新后重试' || '网络错误')
                }
            })
      })
    } else {
      tuhu.toast('请在微信客户端打开')
    }
  }
    // 太平微信扫一扫
    static scanTP = () => {
      if (tuhu.device.isWeixin) {
        WxConfig.share(['scanQRCode']).then((status) => {
        // console.log('配置是否成功', status)
              wx.scanQRCode({
                desc: 'scanQRCode desc',
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                  console.log('resssss', res)
                    let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                    tuhu.navigateTo({
                      url: '/pages/verify/code',
                      data: {
                        verifyCode: result
                      },
                      query: {
                        success: 1,
                        verifyCode: result
                      }
                    })
                  },
                  fail: function (err) {
                    tuhu.toast(err || '网络错误')
                  }
              })
        })
      } else {
        tuhu.toast('请在微信客户端打开')
      }
    }

      // 抖音扫一扫
  static scanDY = (code = '') => {
    if (tuhu.device.isWeixin) {
      console.log('调用扫一扫')
    return new Promise((resolve, reject) => {
      WxConfig.share(['scanQRCode']).then((status) => {
      console.log('配置是否成功1', status)
            wx.scanQRCode({
              desc: 'scanQRCode desc',
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                console.log('抖音扫一扫', res)
                resolve(res)
                },
                fail: function (err) {
                  console.log('scanQR-err', err)
				          tuhu.toast('网络错误,请刷新后重试' || '网络错误')
                }
            })
          })
      })
    } else {
      tuhu.toast('请在微信客户端打开')
    }
  }
  static hideBtn = () => {
    if (tuhu.device.isWeixin) {
      WxConfig.share(['hideMenuItems']).then((status) => {
      console.log('配置是否', status)
        wx.hideMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
          })
      })
    } else {
      // tuhu.toast('请在微信客户端打开')
    }
  }
}

export default WxSdk



// WEBPACK FOOTER //
// ./lib/commons/wxsdk.js